export const fmtInt = (n: number) => (Number.isFinite(n) ? n.toLocaleString() : "—");
export const fmtDateTime = (s: string | number | Date) => new Date(s).toLocaleString();
export const fmtPct = (num: number, denom: number) => denom > 0 && Number.isFinite(num) ? `${((num / denom) * 100).toFixed(2)}%` : "—";
